import { ProductDetailHeader } from '../interfaces/product-details-interfaces.interface';

export const TABLE_HEADERS: ProductDetailHeader[] = [
  {
    isDynamic: false,
  },
  {
    isDynamic: true,
    valueKey: 'parameter-name',
  },
  {
    isDynamic: false,
    valueKey: 'data-type',
  },
  {
    isDynamic: false,
    valueKey: 'unit',
  },
  {
    isDynamic: true,
    valueKey: 'value',
  },
  {
    isDynamic: false,
  },
];
